
import Vue from "vue";
import ImageViewRound from "@/components/atoms/ImageView.vue";
import { showOkCancelDialog } from "@/lib/dialog";
import FolderOutlineIcon from "icons/FolderOutline.vue";
import FolderHiddenIcon from "icons/FolderHidden.vue";
import EqualIcon from "icons/Equal.vue";
import DotsHorizontalIcon from "icons/DotsHorizontal.vue";
import ClickOutside from "vue-click-outside";
import TrashCanOutlineIcon from "icons/TrashCanOutline.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  directives: { ClickOutside },
  components: {
    ImageViewRound,
    FolderOutlineIcon,
    FolderHiddenIcon,
    EqualIcon,
    DotsHorizontalIcon,
    TrashCanOutlineIcon,
  },
  props: {
    to: Object,
    icon: String,
    label: String,
    folderName: String,
    iconPlaceholder: String,
    isActive: Boolean,
    showHandle: Boolean,
    item: Object,
    disabledFolder: {
      type: Boolean,
      default: false,
    },
    customClickFunction: Function, // click時の挙動を外部から指定したい場合用に渡す
    needsDoCustomClickFunction: Boolean, // customClickFunctionの実行要否の判断用に追加
    showProgress: Boolean,
    progress: String,
    progressWidth: String,
    isEditMode: Boolean,
    isManuscriptDeleteMode: Boolean,
    isManuscriptMoveFolderMode: Boolean,
  },
  data() {
    return {
      isShowMenu: false,
    };
  },
  computed: {
    iconColor() {
      // テキスト色（セカンダリ）と同じ色を使用（ダークモード対応）
      // 3点リーダーアイコンの色をテキスト色と合わせる
      // SSR環境ではdocumentが存在しない可能性があるため、存在チェックを追加
      if (typeof document === "undefined") {
        return "#787878"; // デフォルト値（ライトモードのセカンダリテキスト色相当）
      }
      const computedStyle = getComputedStyle(document.documentElement);
      return computedStyle.getPropertyValue("--color-text-secondary").trim() || "#787878";
    },
    isCharactersPath() {
      return this.$route.path.includes("/characters");
    },
  },
  methods: {
    async click() {
      if (this.showHandle) {
        return;
      }
      // マルチ執筆画面内での処理でもisModifiedに引っかかってしまうので、その前に処理を行わせている
      if (this.needsDoCustomClickFunction) {
        this.customClickFunction();
        return;
      }
      if (this.isModified()) {
        const yes = await showOkCancelDialog({
          title: this.$t("manuscriptPage.listItem.confirmDialog.title") as string,
          content: this.$t("manuscriptPage.listItem.confirmDialog.content") as string,
          okButton: this.$t("manuscriptPage.listItem.confirmDialog.okButton") as string,
          cancelButton: this.$t("manuscriptPage.listItem.confirmDialog.cancelButton") as string,
        });
        if (!yes) {
          return;
        }
      }
      this.setModified(false);
      this.$router.push(this.to, () => {});
    },
    setFolder(item) {
      if (this.$mq === "pc") this.click();

      this.$emit("clickSetFolder", { item });
    },
    deleteItem() {
      this.click();
      this.$emit("delete");
    },
    copyItem() {
      this.click();
      this.$emit("copy");
    },
    onClickMenu() {
      this.isShowMenu = true;
    },
    closeMenu() {
      this.isShowMenu = false;
    },
  },
});

interface Props {
  to: object;
  icon: string;
  label: string;
  folderName: string;
  iconPlaceholder: string;
  isActive: boolean;
  showHandle: boolean;
  item: object;
  disabledFolder: boolean;
  customClickFunction: void;
  needsDoCustomClickFunction: boolean;
  showProgress: boolean;
  progress: string;
  progressWidth: string;
  isEditMode: boolean;
  isManuscriptDeleteMode: boolean;
  isManuscriptMoveFolderMode: boolean;
}

interface Data {
  isShowMenu: boolean;
}

interface Computed {
  iconColor: string;
  isCharactersPath: boolean;
}

interface Methods {
  click(): Promise<void>;
  setFolder(item: object): void;
  deleteItem(): void;
  copyItem(): void;
  onClickMenu(): void;
  closeMenu(): void;
}
